import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_ADVISOR_ONLINE_SCHEDULE,
  GET_ADVISOR_ONLINE_SCHEDULES,
  GET_ADVISOR_ONLINE_SCHEDULES_BY_FILTER,
  GET_ADVISOR_ONLINE_SCHEDULES_BY_FILTER_FOR_TABLE,
  ADD_ADVISOR_ONLINE_SCHEDULE,
  UPDATE_ADVISOR_ONLINE_SCHEDULE,
  DELETE_ADVISOR_ONLINE_SCHEDULE
} from '@/queries/modules/advisor-online-schedule/advisor-online-schedule';

export async function getAdvisorOnlineSchedules(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ADVISOR_ONLINE_SCHEDULES,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getAdvisorOnlineSchedules
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAdvisorOnlineSchedulesByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ADVISOR_ONLINE_SCHEDULES_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getAdvisorOnlineSchedulesByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAdvisorOnlineSchedulesByFilterForTable(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ADVISOR_ONLINE_SCHEDULES_BY_FILTER_FOR_TABLE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.getAdvisorOnlineSchedulesByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getAdvisorOnlineSchedule(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ADVISOR_ONLINE_SCHEDULE,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getAdvisorOnlineSchedule
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addAdvisorOnlineSchedule(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_ADVISOR_ONLINE_SCHEDULE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', newItemSuccess(data.addAdvisorOnlineSchedule.topicLocal));

      return data.addAdvisorOnlineSchedule;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateAdvisorOnlineSchedule(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_ADVISOR_ONLINE_SCHEDULE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      context.commit('setSuccess', updateItemSuccess(data.updateAdvisorOnlineSchedule.topicLocal));

      return data.updateAdvisorOnlineSchedule
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteAdvisorOnlineSchedule(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_ADVISOR_ONLINE_SCHEDULE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', deleteItemSuccess(data.deleteAdvisorOnlineSchedule.topicLocal));

      return data.deleteAdvisorOnlineSchedule
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

